import React, { useEffect, useRef } from "react";

interface Props {
    children: React.ReactNode;
    id?: string;
    open?: boolean;
}

function DropDownContainer({ children, id, open = true }: Props) {
    const ref = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (open) ref.current?.removeAttribute('inert');
        else ref.current?.setAttribute('inert', '');
    }, [open]);
    return <div ref={ref} id={id} aria-hidden={!open} className={`dropDownContainer${open ? ' open' : ''}`}>
        <div className="dropDownInner">{children}</div>
    </div>;
}

export default DropDownContainer;
